export const dataGridHeight = "80vh";
export const dataGridRowHeight = 25;
export const dataGridHeaderFooterHeight = 30;
export const dataGridPageSizeOption = [20, 50, 100];
export const dataGridPageSize = 20;
export const formGap = "10px";
export const menuHeight = 35;
